import React from 'react';
import { Pressable } from 'react-native';
import { Feather } from '@expo/vector-icons';

import { useTheme } from '../../theme';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../text/Text';

// One side menu row: Feather icon, label; isDanger for Logout.
const NavigationMenuItem = ({
	label,
	onPress,
	icon,
	isDanger = false,
	isLast = false,
}) => {
	const styles = useThemedStyles(createStyles);
	const { theme: { ui: { colors } } } = useTheme();

	return (
		<Pressable
			onPress={onPress}
			accessibilityRole="button"
			accessibilityLabel={label}
			style={({ pressed }) => [styles.menuItem, isLast && styles.menuItemLast, pressed && styles.pressed]}
		>
			{
				icon && (
					<Feather
						name={icon}
						size={22}
						color={isDanger ? colors.danger : colors.textSecondary}
					/>
				)
			}
			<Text style={[styles.menuItemText, isDanger && styles.menuItemTextDanger]}>
				{label}
			</Text>
		</Pressable>
	);
};

const createStyles = ({ ui: { colors, type, space, touch } }) => ({
	menuItem: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: 14,
		minHeight: touch.row,
		paddingHorizontal: space.gutter,
		borderBottomWidth: 1,
		borderBottomColor: colors.border,
	},
	menuItemLast: {
		borderBottomWidth: 0,
	},
	pressed: {
		backgroundColor: colors.card,
	},
	menuItemText: {
		...type.rowTitle,
		color: colors.text,
		flexShrink: 1,
	},
	menuItemTextDanger: {
		...type.rowTitleSemibold,
		color: colors.danger,
	},
});

export default NavigationMenuItem;
